export const actions = {
  CPS_LOAD_REQUESTED: 'CPS_LOAD_REQUESTED',
  CPS_LOAD_SUCCEEDED: 'CPS_LOAD_SUCCEEDED',
  CPS_LOAD_FILED: 'CPS_LOAD_FILED',

  CP_TIPOS_LOAD_REQUESTED: 'CP_TIPOS_LOAD_REQUESTED',
  CP_TIPOS_LOAD_SUCCEEDED: 'CP_TIPOS_LOAD_SUCCEEDED',
  CP_TIPOS_LOAD_FILED: 'CP_TIPOS_LOAD_FILED',

  CP_UPDATE_REQUESTED: 'CP_UPDATE_REQUESTED',
  CP_UPDATE_SUCCEEDED: 'CP_UPDATE_SUCCEEDED',
  CP_UPDATE_FILED: 'CP_UPDATE_FILED',

  CP_INSERT_REQUESTED: 'CP_INSERT_REQUESTED',
  CP_INSERT_SUCCEEDED: 'CP_INSERT_SUCCEEDED',
  CP_INSERT_FILED: 'CP_INSERT_FILED',

  CP_DELETE_REQUESTED: 'CP_DELETE_REQUESTED',
  CP_DELETE_SUCCEEDED: 'CP_DELETE_SUCCEEDED',
  CP_DELETE_FILED: 'CP_DELETE_FILED',
}

export const getCodigosPostalesAction = (dispatch, formFilter) => {
  dispatch({
    type: actions.CPS_LOAD_REQUESTED,
    payload: formFilter,
  })
}

export const getTiposCodigosPostalesAction = dispatch => {
  dispatch({
    type: actions.CP_TIPOS_LOAD_REQUESTED,
  })
}

export const onSubmitInsertCodigoPostalFormAction = (dispatch, formCodigoPostal) => {
  dispatch({
    type: actions.CP_INSERT_REQUESTED,
    payload: formCodigoPostal,
  })
}

export const onSubmitUpdateCodigoPostalFormAction = (dispatch, formCodigoPostal) => {
  dispatch({
    type: actions.CP_UPDATE_REQUESTED,
    payload: formCodigoPostal,
  })
}

export const deleteCodigoPostalAction = (dispatch, id) => {
  dispatch({
    type: actions.CP_DELETE_REQUESTED,
    payload: id,
  })
}
